import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';


export const CustomersReducer = combineReducers({
                                                    records: recordsReducer,
                                                });